import $ from 'jquery';

/**
 * Mobile Nav Class
 * Includes some basic mobile navigation logic
 */
class MobileNav {
    constructor() {
        this.url = document.location.origin;
        this.plusSrc = `${this.url}/wp-content/themes/side-by-side/img/src/icons/plus.svg`;
        this.minusSrc = `${this.url}/wp-content/themes/side-by-side/img/src/icons/minus.svg`;
    }

    /**
     * Initilization Function
     * @returns {void}
     */
    init() {
        this.clickEventHandler();
        this.addArrowsToNavItemsWithChildren();
        this.addElementsToNavDom();
    }

    /**
     * Add the close button to the mobile nav element
     * @returns {void}
     */
    addElementsToNavDom() {
        $('.mobile-nav .menu-header-menu-container')
            .append('<a class="button arrow" href="#">Donate</a>');
    }

    /**
     * If a list item has children, add an element with an arrow to the list item
     * @returns {void}
     */
    addArrowsToNavItemsWithChildren() {
        // const arrow = '<span class="arrow fas fa-plus"></span>';
        const arrow = `<img class='arrow' src='${this.plusSrc}' alt=''>`
        $('.mobile-nav .menu-item-has-children').each((i, listItem) => {
            $(listItem).children('a').after(arrow);
        });
    }

    /**
     * Handle click events
     * @returns {void}
     */
    clickEventHandler() {
        // Toggle open/close nav on hamburger click
        $('.mobile-nav').on('click', (e) => {
            const $target = e.target;

            if ($($target).hasClass('fa-bars') || $($target).parent().hasClass('fa-bars')) {
                $('.mobile-nav .menu-header-nav-top-container').toggleClass('active');
                $('body').toggleClass('menu');
            }
        });

        // Handle click events inside mobile nav
        $('.menu-header-nav-top-container').on('click', (e) => {
            const $target = e.target;
            const $parent = $($target).parent();

            if ($($target).hasClass('arrow')) {
                // $($target).toggleClass('fa-minus').toggleClass('fa-plus');
                // $($target).attr('src', this.minusSrc);

                // Closing all other menus before opening current
                // $('.arrow').attr('src', this.plusSrc);
                // $('.sub-menu').removeClass('visible');

                this.toggleImgSrc($target);
                $($target).next().toggleClass('visible');
            } else if ($($target).parent().hasClass('arrow')) {
                // $($parent).toggleClass('fa-minus').toggleClass('fa-plus');
                this.toggleImgSrc($parent);
                $($parent).next().toggleClass('visible');
            } else if ($($target).hasClass('close-mobile-nav')) {
                $('.mobile-nav .menu-header-nav-top-container').removeClass('active');
            }
        });
    }

    /**
     * Toggles the img src of element
     * @param $target the jQuery object to toggle the src of
     * @returns {void}
     */
    toggleImgSrc($target) {
        if ($($target).attr('src') == this.plusSrc) {
            $($target).attr('src', this.minusSrc);
        } else if ($($target).attr('src') == this.minusSrc) {
            $($target).attr('src', this.plusSrc);
        }
    }
}

export default MobileNav;
